<template>
  <div class="py-4 bg-light_gray border-b border-section_border" :class="{'border-t': isFull}">
    <div v-if="isOwner" class="px-4 flex align-center border-section_border" :class="{'border-b mb-4 pb-4': isFull}">
      <div class="flex-1 pr-1 mr-1">
        <a @click="handleEdit" class="button-secondary button-is-small flex justify-center">
          <span class="block pt-1 h-5">
            <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m331.266839 213.557127 1.4046-1.4046c.208088-.208089.317335-.447391.32774-.717907.010404-.270515-.078034-.499413-.265314-.686693l-1.49824-1.49824c-.18728-.18728-.416177-.275717-.686693-.265313-.270515.010404-.509818.119651-.717906.32774l-1.4046 1.4046zm-8.177893 8.177892 7.803333-7.834545-2.8092-2.8092-7.834546 7.803332zm-4.088946 1.248534 3.65196-.998827-2.653133-2.653133z" transform="translate(-319 -209)"/></svg>
          </span>
          <span class="pl-2">{{ $t('tour_change_label') }}</span>
        </a>
      </div>
      <div class="flex-1 pl-1 ml-1">
        <a @click="confirmDelete" class="button-secondary button-is-small flex justify-center">
          <span class="block pt-1 h-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path d="m329.916667 254.333333v-1.166666h-2.916667l-.984375-1.166667h-3.864583l-.984375 1.166667h-2.916667v1.166666zm-2.734375 11.666667c.413194 0 .777777-.157986 1.09375-.473958.315972-.315973.473958-.680556.473958-1.09375v-8.932292h-9.333333v8.932292c0 .413194.157986.777777.473958 1.09375.315972.315972.680556.473958 1.09375.473958z" transform="translate(-317 -252)"/>
          </svg>
          </span>
          <span class="pl-2">{{ $t('tour_delete_label') }}</span>
        </a>
      </div>
    </div>
    <div v-if="isFull" class="my-4 px-6 pb-4 border-b border-section_border text-btn_secondary font-light">
      <p class="mb-6">
        <a @click="copy" class="flex">
          <span class="block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="m292 273v-16.3125l-4.6875-4.6875h-10.3125v21zm-2-14h-5v-5h1v4h4zm-1 17v-2h-13v-19h-2v21z" transform="translate(-271 -252)"/>
            </svg>
          </span>
          <span class="pl-2">{{ $t('tour_cory_share_url') }}</span>
        </a>
      </p>
      <p class="mb-6">
        <a @click="mailTo" class="flex">
          <span class="block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill-rule="evenodd" transform="translate(-271 -280)">
              <rect width="24" height="17" x="271" y="283.5" rx="1"/>
              <path stroke="#fff" d="m272.958984 286 10.041016 7.064453 9.505859-7.064453"/>
            </g>
            </svg>
          </span>
          <span class="pl-2">{{ $t('tour_send_mail') }}</span>
        </a>
      </p>
      <p>
        <a @click="lineTo" class="flex">
          <img src="@/assets/images/icon-line.svg" alt="" class="block" />
          <span class="pl-2">{{ $t('tour_send_line') }}</span>
        </a>
      </p>
    </div>
    <div v-if="isFull" class="mt-4 px-4">
      <a class="button-secondary block button-icon icon-left" @click="handleBack">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back_to_plan_top_label') }}</span>
      </a>
    </div>
    <div v-if="isFull" class="mt-4 px-4">
      <a :href="tohoku_maas_url()" class="button-secondary block button-icon icon-left">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_tohoku_maas_link') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../constants'

export default {
  props: {
    planId: {
      type: String
    },
    isFull: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'plans/isOwner'
    })
  },
  methods: {
    handleBack: function () {
      this.$router.push({ path: '/plans' })
    },
    handleEdit: function () {
      this.$router.push({ name: 'editPlan', id: this.planId })
    },
    confirmDelete: function () {
      this.$confirm({
        message: this.$t('tour_delete_confirm_message'),
        success: () => {
          this.handleDelete()
        }
      })
    },
    handleDelete: function () {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('plans/deletePlan', this.planId)
        .then(() => {
          this.$store.dispatch('loading/endLoading')
          this.$router.push({ path: '/plans' })
        })
    },
    copy: function () {
      this.$alert({ message: this.$t('tour_copied_message') })
      this.copyTextToClipboard(location.href);
    },
    mailTo: function () {
      location.href = "mailto:?body=" + encodeURIComponent(location.href);
    },
    lineTo: function () {
      location.href = "https://social-plugins.line.me/lineit/share?url=" + encodeURIComponent(location.href);
    },
    copyTextToClipboard: function (text) {
      var doc = document.createElement("textarea");
      doc.textContent = text;
      var body = document.getElementsByTagName("body")[0];
      body.appendChild(doc);
      doc.select();
      var ret = document.execCommand('copy');
      body.removeChild(doc);
      return ret;
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>
